import { Nav } from "react-bootstrap";

export default function Footer() {
	return (
		<footer className="footer bg-white border border-shadow text-shadow mt-5">
			<Nav>
				<Nav.Link href="/legal">Terms and conditions</Nav.Link>
				<Nav.Link href="/privacy">Privacy policy</Nav.Link>
				<Nav.Link href="/support">Contact support</Nav.Link>
			</Nav>
		</footer>
	);
}
